export enum RouteName {
	DISCOVER = 'discover',
	EVALUATE = 'evaluate',
	PREPARE_TO_APPLY = 'apply',
	COMMIT = 'commit',
	STUDY = 'study',
	GET_READY = 'get_ready',
	TOOLS = 'tools',
	MY_JOURNEY = 'my-journey',
	REGISTRATION_INCENTIVE = 'registration_incentive',
}
